// Ciudades Imperiales + Rif · 6 nights / 7 days · Tánger → Tetuán → Chefchaouen → Meknes → Fez → Marrakech
const T = (es, en, fr) => ({ es, en, fr });

export const DAY_CIRF_TANGER_TETUAN = {
  route_id: "cirf-tanger-tetuan",
  id: "cirf-d1",
  image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=2000&q=85",
  accent: "#5A7F9C",
  title: T(
    "Tánger · Tetuán",
    "Tangier · Tetouan",
    "Tanger · Tétouan",
  ),
  chronologySummary: T(
    "Llegada a Tánger y continuación a Tetuán para conocer su medina con un guía local.",
    "Arrival in Tangier and onward to Tetouan for a guided visit of its medina.",
    "Arrivée à Tanger puis route vers Tétouan pour une visite guidée de sa médina.",
  ),
  body: {
    es: "Llegada por la mañana a Tánger. Tras el control de pasaportes y la recogida de equipajes, encuentro con el chófer y salida hacia Tetuán, conocida como «La Paloma Blanca». Visita guiada de su medina, declarada Patrimonio de la Humanidad por la UNESCO, donde se aprecia la influencia andalusí. Cena y alojamiento en riad dentro de la medina u hotel 4★. Según el horario de llegada, la visita podría trasladarse a la mañana siguiente.",
    en: "Morning arrival in Tangier. After passport control and baggage collection, meet the driver and travel to Tetouan, known as the White Dove. Guided visit of its UNESCO-listed medina and Andalusian heritage. Dinner and overnight in a medina riad or 4-star hotel. Depending on arrival time, the visit may take place the following morning.",
    fr: "Arrivée le matin à Tanger. Après les formalités et la récupération des bagages, rencontre avec le chauffeur et route vers Tétouan, la Colombe Blanche. Visite guidée de sa médina classée UNESCO et de son héritage andalou. Dîner et nuit en riad de la médina ou hôtel 4 étoiles. Selon l'heure d'arrivée, la visite pourra avoir lieu le lendemain matin.",
  },
  culture: [
    {
      title: T("Tetuán · UNESCO", "Tetouan · UNESCO", "Tétouan · UNESCO"),
      body: T(
        "Su medina, declarada Patrimonio Mundial en 1997, es la más auténticamente andalusí de Marruecos: trazada por familias granadinas tras la caída de Al-Ándalus.",
        "Its medina, UNESCO-listed since 1997, is the most authentically Andalusian in Morocco — laid out by Granadan families after the fall of Al-Andalus.",
        "Sa médina, inscrite UNESCO en 1997, est la plus authentiquement andalouse du Maroc — tracée par des familles grenadines après la chute d'Al-Andalus.",
      ),
    },
  ],
};

export const DAY_CIRF_CHEFCHAOUEN = {
  route_id: "cirf-chefchaouen",
  id: "cirf-d2",
  image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2000&q=85",
  accent: "#5A7F9C",
  title: T(
    "Chefchaouen y las montañas del Rif",
    "Chefchaouen and the Rif mountains",
    "Chefchaouen et les montagnes du Rif",
  ),
  chronologySummary: T(
    "Atravesamos las montañas del Rif y las cascadas de Akchour para recorrer las plazas, callejuelas azules y rincones históricos de Chefchaouen.",
    "We cross the Rif Mountains and Akchour waterfalls to explore Chefchaouen’s blue alleys, squares and historic landmarks.",
    "Nous traversons le Rif et les cascades d’Akchour pour parcourir les ruelles bleues, les places et les sites historiques de Chefchaouen.",
  ),
  body: {
    es: "Salida hacia Chefchaouen, situada entre las montañas Tisouka y Megou, en plena cordillera del Rif. Durante el trayecto realizaremos una parada en las Cascadas de Akchour para disfrutar del paisaje y realizar fotografías. Llegada a Chefchaouen, el famoso «pueblo azul», donde realizaremos una visita guiada recorriendo sus callejuelas y plazas más emblemáticas: Plaza Uta el-Hammam, Gran Mezquita, Kasbah del siglo XVII y sus jardines, Plaza Makhzen, Bab el-Ansar y Fuente Ras el-Maa. Por la tarde tiempo libre para descubrir la ciudad a vuestro ritmo, pasear junto al riachuelo y conocer el barrio de los lavaderos tradicionales de Sebbanin. Cena y alojamiento en riad dentro de la medina.",
    en: "Departure for Chefchaouen, set between the Tisouka and Megou mountains in the heart of the Rif range. On the way we stop at the Akchour Waterfalls to enjoy the landscape and take photos. We arrive in Chefchaouen, the famous «blue town», for a guided walk through its most emblematic alleys and squares: Uta el-Hammam square, the Grand Mosque, the 17th-century Kasbah and its gardens, Makhzen square, Bab el-Ansar and the Ras el-Maa fountain. Free time in the afternoon to explore at your own pace, stroll along the stream and discover the traditional Sebbanin laundry quarter. Dinner and overnight in a medina riad.",
    fr: "Départ pour Chefchaouen, lovée entre les montagnes Tisouka et Megou, au cœur du Rif. En route, arrêt aux cascades d'Akchour pour profiter du paysage et faire des photos. Arrivée à Chefchaouen, le célèbre « village bleu », pour une visite guidée de ses ruelles et places les plus emblématiques : place Uta el-Hammam, Grande Mosquée, Kasbah du XVIIe siècle et ses jardins, place Makhzen, Bab el-Ansar et fontaine Ras el-Maa. L'après-midi, temps libre pour découvrir la ville à votre rythme, flâner le long du ruisseau et visiter le quartier des lavoirs traditionnels de Sebbanin. Dîner et nuit en riad de la médina.",
  },
  culture: [
    {
      title: T("Chefchaouen · ciudad azul", "Chefchaouen · the blue city", "Chefchaouen · la ville bleue"),
      body: T(
        "Fundada en 1471 como bastión contra los portugueses. El característico añil cubre fachadas y callejuelas desde los años 30: tradición sefardí y simbolismo espiritual.",
        "Founded in 1471 as a stronghold against the Portuguese. The signature indigo has covered façades and alleys since the 1930s — a Sephardic tradition with spiritual meaning.",
        "Fondée en 1471 comme bastion contre les Portugais. L'indigo emblématique recouvre façades et ruelles depuis les années 1930 — tradition sépharade au sens spirituel.",
      ),
    },
  ],
};

const DAY_03 = {
  route_id: "cirf67-volubilis-meknes-fez",
  id: "cirf67-d3",
  image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=2000&q=85",
  accent: "#5A6B4F",
  title: T(
    "Chefchaouen · Volubilis · Moulay Idriss · Meknes · Fez",
    "Chefchaouen · Volubilis · Moulay Idriss · Meknes · Fez",
    "Chefchaouen · Volubilis · Moulay Idriss · Meknès · Fès",
  ),
  chronologySummary: T(
    "De Chefchaouen viajamos a las ruinas romanas de Volubilis y la ciudad santa de Moulay Idriss, visitamos Meknes y terminamos en Fez.",
    "From Chefchaouen we travel to Roman Volubilis and holy Moulay Idriss, visit imperial Meknes and finish the day in Fez.",
    "De Chefchaouen, nous rejoignons Volubilis et Moulay Idriss, visitons la cité impériale de Meknès puis terminons la journée à Fès.",
  ),
  body: {
    es: "Salida temprano en dirección Meknes. Durante la ruta visitaremos Volubilis, el yacimiento arqueológico romano más importante de Marruecos. Entre sus principales monumentos destacan el arco de triunfo, el capitolio, la Casa de Baco y antiguos mosaicos romanos. De camino pasaremos por Moulay Idriss, ciudad santa y centro espiritual del país. Llegada a Meknes, una de las ciudades imperiales más monumentales de Marruecos. Visita guiada de la ciudad y de sus monumentos más importantes: Bab al Mansour, Mausoleo de Moulay Ismail, graneros y establos «Heri es Souani» y prisión subterránea «Habs Qara». Tras la visita continuación hacia Fez. Cena y alojamiento en riad dentro de la medina o hotel 4★.",
    en: "Early departure towards Meknes. On the way we visit Volubilis, Morocco's most important Roman archaeological site — triumphal arch, capitolium, House of Bacchus and ancient Roman mosaics. We pass through Moulay Idriss, a holy city and one of the country's main spiritual centres. We then arrive in Meknes, one of Morocco's most monumental imperial cities, for a guided tour of its main monuments: Bab al Mansour, the Mausoleum of Moulay Ismail, the royal granaries and stables «Heri es Souani» and the underground prison «Habs Qara». After the visit, we continue to Fez. Dinner and overnight in a medina riad or 4★ hotel.",
    fr: "Départ matinal vers Meknès. En route, visite de Volubilis, le site archéologique romain le plus important du Maroc — arc de triomphe, capitole, maison de Bacchus et mosaïques romaines. Passage par Moulay Idriss, ville sainte et l'un des principaux centres spirituels du pays. Arrivée à Meknès, l'une des cités impériales les plus monumentales du Maroc, pour une visite guidée de ses monuments principaux : Bab al Mansour, mausolée de Moulay Ismaïl, greniers et écuries royales « Heri es Souani » et prison souterraine « Habs Qara ». Route vers Fès. Dîner et nuit en riad de la médina ou hôtel 4★.",
  },
  culture: [
    {
      title: T("Volubilis · UNESCO", "Volubilis · UNESCO", "Volubilis · UNESCO"),
      body: T(
        "Capital de la provincia romana de Mauretania Tingitana en el siglo I a.C. Sus mosaicos están entre los mejor conservados del Magreb.",
        "Capital of the Roman province of Mauretania Tingitana in the 1st c. BC. Its mosaics are among the best-preserved in the Maghreb.",
        "Capitale de la province romaine de Maurétanie Tingitane au Ier s. av. J.-C. Ses mosaïques figurent parmi les mieux conservées du Maghreb.",
      ),
    },
    {
      title: T("Moulay Ismail · el constructor", "Moulay Ismail · the builder", "Moulay Ismaïl · le bâtisseur"),
      body: T(
        "Reinó 55 años (1672-1727). Hizo de Meknes su capital y la dotó de 40 km de murallas, palacios y los establos para 12.000 caballos.",
        "Reigned for 55 years (1672-1727). Made Meknes his capital — 40 km of walls, palaces and stables for 12,000 horses.",
        "Régna 55 ans (1672-1727). Fit de Meknès sa capitale — 40 km de remparts, palais et écuries pour 12 000 chevaux.",
      ),
    },
  ],
};

export const DAY_CIRF_FEZ_MEDINA = {
  route_id: "cirf-fez-medina",
  id: "cirf-d-fez",
  image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=2000&q=85",
  accent: "#C16542",
  title: T(
    "Fez · la capital cultural de Marruecos",
    "Fez · Morocco's cultural capital",
    "Fès · capitale culturelle du Maroc",
  ),
  chronologySummary: T(
    "Recorremos a pie Fez el-Bali, sus zocos, escuelas coránicas, talleres y tenerías tradicionales, con panorámicas de la ciudad imperial.",
    "We explore Fez el-Bali on foot, including its souks, Koranic schools, workshops and traditional tanneries, with city panoramas.",
    "Nous parcourons Fès el-Bali à pied, avec ses souks, écoles coraniques, ateliers et tanneries, puis admirons la ville depuis ses belvédères.",
  ),
  body: {
    es: "Hoy descubriremos Fez el-Bali, la antigua medina de Fez y una de las más auténticas y mejor conservadas del mundo árabe. Acompañados por un guía local recorreremos sus laberínticas callejuelas medievales repletas de talleres artesanales, mezquitas, palacios, escuelas coránicas y zocos tradicionales. Fez es considerada la ciudad imperial más espiritual y cultural de Marruecos. La visita se realiza completamente a pie, ya que en esta medina declarada Patrimonio de la Humanidad por la UNESCO está prohibido el acceso de vehículos. También visitaremos las tenerías tradicionales, miradores panorámicos y diferentes barrios históricos organizados alrededor de mezquitas, fuentes, hornos y hammams. Cena y alojamiento en riad dentro de la medina o hotel 4★.",
    en: "Today we discover Fez el-Bali, the ancient medina of Fez — one of the most authentic and best-preserved in the Arab world. With a local guide we walk through medieval alleys packed with artisan workshops, mosques, palaces, Koranic schools and traditional souks. Fez is considered the country's most spiritual and cultural imperial city. The visit is entirely on foot — vehicles are forbidden in this UNESCO-listed medina. We also visit the traditional tanneries, panoramic viewpoints and several historic neighbourhoods organised around mosques, fountains, ovens and hammams. Dinner and overnight in a medina riad or 4★ hotel.",
    fr: "Aujourd'hui, découverte de Fès el-Bali, l'ancienne médina de Fès — l'une des plus authentiques et les mieux conservées du monde arabe. Avec un guide local, nous parcourons des ruelles médiévales remplies d'ateliers artisanaux, mosquées, palais, écoles coraniques et souks traditionnels. Fès est considérée comme la ville impériale la plus spirituelle et culturelle du pays. La visite se fait entièrement à pied — les véhicules y sont interdits. Visite des tanneries traditionnelles, des miradors panoramiques et de quartiers historiques organisés autour de mosquées, fontaines, fours et hammams. Dîner et nuit en riad de la médina ou hôtel 4★.",
  },
  culture: [
    {
      title: T("Al-Qarawiyyin · universidad más antigua del mundo", "Al-Qarawiyyin · world's oldest university", "Al-Qarawiyyin · plus ancienne université du monde"),
      body: T(
        "Fundada en 859 d.C. por Fátima al-Fihri. UNESCO y Guinness la reconocen como la universidad más antigua del mundo todavía en funcionamiento.",
        "Founded in 859 CE by Fatima al-Fihri. UNESCO and Guinness recognise it as the world's oldest continuously operating university.",
        "Fondée en 859 par Fatima al-Fihri. UNESCO et Guinness la reconnaissent comme la plus ancienne université au monde toujours en activité.",
      ),
    },
    {
      title: T("Chouara · tenería del s.XI", "Chouara · 11th-century tannery", "Chouara · tannerie du XIe siècle"),
      body: T(
        "Las tinas multicolor funcionan ininterrumpidamente desde el siglo XI con los mismos colorantes naturales: índigo, alheña, azafrán y amapola.",
        "Multicoloured vats running without interruption since the 11th century — same natural dyes: indigo, henna, saffron and poppy.",
        "Cuves multicolores en fonctionnement depuis le XIe siècle — mêmes colorants naturels : indigo, henné, safran et coquelicot.",
      ),
    },
  ],
};

export const DAY_CIRF_FEZ_MARRAKECH = {
  route_id: "cirf-fez-marrakech",
  id: "cirf-d-fmrk",
  image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=2000&q=85",
  accent: "#5A6B4F",
  title: T(
    "Fez · Medio Atlas · Marrakech",
    "Fez · Middle Atlas · Marrakech",
    "Fès · Moyen Atlas · Marrakech",
  ),
  chronologySummary: T(
    "Cruzamos el Medio Atlas por Ifrane, los bosques de cedros, Khenifra y Beni Mellal antes de llegar al ambiente de Jemaa el-Fna.",
    "We cross the Middle Atlas via Ifrane, the cedar forests, Khenifra and Beni Mellal before reaching the atmosphere of Jemaa el-Fna.",
    "Nous traversons le Moyen Atlas par Ifrane, les forêts de cèdres, Khénifra et Beni Mellal avant de rejoindre l’ambiance de Jemaa el-Fna.",
  ),
  body: {
    es: "Hoy nos espera una larga jornada atravesando algunos de los paisajes más variados del país. Recorreremos la cordillera del Medio Atlas en dirección Marrakech. Durante la ruta pasaremos por Ifrane, conocida como «la pequeña Suiza»; los bosques de cedros gigantes donde habitan macacos de Berbería; Azrou, Khenifra, pueblos bereberes del Atlas y Beni Mellal. Llegada a Marrakech. Alojamiento en riad dentro de la medina u hotel 5★. Existe la posibilidad de realizar este trayecto en avión o de añadir una noche adicional en el lago Bin el Ouidane para dividir la ruta en dos jornadas. Se recomienda visitar la Plaza Jemaa el-Fna al atardecer, cuando se llena de narradores, acróbatas, encantadores de serpientes, puestos de comida callejera, músicos y artistas. Una experiencia imprescindible. El servicio de vehículo con chófer finaliza este día.",
    en: "A long day across some of Morocco's most varied landscapes. We cross the Middle Atlas range towards Marrakech. Along the way we drive through Ifrane — known as «little Switzerland» —, the giant cedar forests home to Barbary macaques, Azrou, Khenifra, Berber Atlas villages and Beni Mellal. Arrival in Marrakech. Accommodation in a medina riad or 5★ hotel. The route can also be done by plane, or split into two days with an extra night at the Bin el Ouidane lake. We recommend visiting Jemaa el-Fna square at sunset, when it fills with storytellers, acrobats, snake charmers, street-food stalls, musicians and street artists — an unmissable experience. The driver service ends today.",
    fr: "Longue journée à travers certains des paysages les plus variés du pays. Nous traversons le Moyen Atlas en direction de Marrakech. En route, nous passons par Ifrane — la « petite Suisse » —, les forêts de cèdres géants habitées par les macaques de Berbérie, Azrou, Khenifra, villages berbères de l'Atlas et Beni Mellal. Arrivée à Marrakech. Hébergement en riad de la médina ou hôtel 5★. Possibilité de réaliser ce trajet en avion ou d'ajouter une nuit au lac Bin el Ouidane pour fractionner la route. Nous recommandons la place Jemaa el-Fna au coucher du soleil, lorsqu'elle s'anime de conteurs, acrobates, charmeurs de serpents, stands de cuisine de rue, musiciens et artistes — une expérience incontournable. Le service du chauffeur prend fin ce jour-là.",
  },
  culture: [
    {
      title: T("Ifrane · la pequeña Suiza", "Ifrane · little Switzerland", "Ifrane · la petite Suisse"),
      body: T(
        "Construida en los años 30 con chalés de tejado a dos aguas. A 1.665 m de altitud, nieva en invierno y los cedros del Atlas la convierten en oasis alpino.",
        "Built in the 1930s with chalets and gabled roofs. At 1,665 m it snows in winter and the Atlas cedars turn it into an alpine oasis.",
        "Construite dans les années 1930 avec chalets et toits à pignons. À 1 665 m, il neige en hiver et les cèdres de l'Atlas en font une oasis alpine.",
      ),
    },
  ],
};

export const DAY_CIRF_MARRAKECH_MEDINA = {
  route_id: "cirf-marrakech-medina",
  id: "cirf-d-mrk",
  image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2000&q=85",
  accent: "#C16542",
  title: T(
    "Marrakech · medina, zocos y Jemaa el-Fna",
    "Marrakech · medina, souks and Jemaa el-Fna",
    "Marrakech · médina, souks et Jemaa el-Fna",
  ),
  chronologySummary: T(
    "Visita guiada por la Koutoubia, el Palacio de la Bahía, los talleres de los zocos y Jemaa el-Fna, con tarde libre en la medina.",
    "A guided visit to the Koutoubia, Bahia Palace, souk workshops and Jemaa el-Fna, with free time in the medina.",
    "Visite guidée de la Koutoubia, du Palais de la Bahia, des ateliers des souks et de Jemaa el-Fna, puis temps libre dans la médina.",
  ),
  body: {
    es: "Por la mañana visita guiada a pie por la medina de Marrakech. Descubriremos la Koutoubia, el Palacio Bahía, los zocos y talleres artesanales, y una farmacia bereber tradicional. Durante la visita veremos artesanos trabajando cuero, alfombras, cerámica y babuchas tradicionales. Regreso a la Plaza Jemaa el-Fna y tarde libre para disfrutar de la ciudad, practicar el regateo o perderse por la medina. La visita guiada puede ampliarse para incluir la Madraza Ben Youssef, el Museo Ben Youssef, las Tumbas Saadíes y los Jardines Majorelle. Alojamiento en riad dentro de la medina u hotel 5★.",
    en: "Morning guided walking tour of the Marrakech medina. We discover the Koutoubia, the Bahia Palace, the souks and artisan workshops, and a traditional Berber pharmacy. Along the way we see artisans working leather, carpets, ceramics and traditional babouches. Back to Jemaa el-Fna square and free afternoon to enjoy the city, bargain in the souks or get lost in the medina. The tour can be extended to include the Ben Youssef Madrasa, the Ben Youssef Museum, the Saadian Tombs and the Majorelle Gardens. Overnight in a medina riad or 5★ hotel.",
    fr: "Visite guidée à pied de la médina de Marrakech le matin. Nous découvrons la Koutoubia, le palais Bahia, les souks et les ateliers d'artisans, ainsi qu'une herboristerie berbère traditionnelle. Nous voyons des artisans travailler le cuir, les tapis, la céramique et les babouches traditionnelles. Retour à la place Jemaa el-Fna et après-midi libre pour profiter de la ville, marchander dans les souks ou se perdre dans la médina. La visite peut être prolongée pour inclure la médersa Ben Youssef, le musée Ben Youssef, les tombeaux saadiens et les jardins Majorelle. Nuit en riad de la médina ou hôtel 5★.",
  },
  culture: [
    {
      title: T("Jemaa el-Fna · UNESCO", "Jemaa el-Fna · UNESCO", "Jemaa el-Fna · UNESCO"),
      body: T(
        "Inscrita como Patrimonio Oral e Inmaterial de la Humanidad: cada noche, narradores y músicos perpetúan tradiciones orales bereberes de siglos.",
        "Listed as a UNESCO Oral and Intangible Heritage: each night, storytellers and musicians keep centuries-old Berber oral traditions alive.",
        "Inscrite au Patrimoine Oral et Immatériel de l'UNESCO : chaque soir, conteurs et musiciens font vivre des traditions orales berbères séculaires.",
      ),
    },
  ],
};

export const DAY_CIRF_RETURN_MARRAKECH = {
  route_id: "cirf-return",
  id: "cirf-d-ret",
  image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=2000&q=85",
  accent: "#5C5248",
  title: T("Regreso desde Marrakech", "Return from Marrakech", "Retour depuis Marrakech"),
  chronologySummary: T(
    "Últimos momentos en Marrakech y traslado desde el alojamiento hasta el aeropuerto para tomar el vuelo de regreso al punto de origen.",
    "Final moments in Marrakech and transfer from the accommodation to the airport for the return flight home.",
    "Derniers instants à Marrakech puis transfert de l’hébergement à l’aéroport pour prendre le vol retour.",
  ),
  body: {
    es: "A la hora acordada, traslado al aeropuerto de Marrakech para tomar el vuelo de regreso.",
    en: "At the agreed time, transfer to Marrakech airport for the return flight.",
    fr: "À l'heure convenue, transfert à l'aéroport de Marrakech pour le vol retour.",
  },
  culture: [],
};

export const PROGRAM_CI_RIF_67 = {
  routeId: "tourCiudadesImperialesRif67",
  chronologyVariant: "cirf",
  duration_key: "cirf6n7d",
  duration: T("6 noches / 7 días", "6 nights / 7 days", "6 nuits / 7 jours"),
  prices: { low: 1290, mid: 1490, high: 1690, premium: 1890 },
  meta: {
    es: {
      title: "Ciudades imperiales y el Rif.",
      eyebrow_prefix: "Circuito · Ciudades imperiales + Rif",
      place: "Tánger · Chefchaouen · Meknes · Fez · Marrakech",
      subtitle: "De Tánger a Marrakech recorriendo el norte cultural, el pueblo azul del Rif, las ciudades imperiales y la ciudad roja.",
      hero_image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=2400&q=85",
      airports: "Entrada Tánger · Salida Marrakech",
      quick_airports: "Tánger / Marrakech",
      quick_places: "Tánger · Tetuán · Chefchaouen · Volubilis · Meknes · Fez · Ifrane · Marrakech",
      highlights: "Tetuán · Chefchaouen · Volubilis · Fez el-Bali · Jemaa el-Fna",
      description_title: "Una inmersión total en el Marruecos cultural.",
      description: [
        "Marruecos posee un rico legado histórico y arquitectónico que podemos apreciar en sus «Ciudades Imperiales».",
        "Este completo circuito recorre el país de norte a sur descubriendo medinas Patrimonio de la Humanidad, pueblos azules del Rif, montañas, ciudades imperiales y los contrastes entre el Mediterráneo y Marrakech.",
        "Una experiencia diseñada para viajeros que desean descubrir el Marruecos más auténtico, cultural y monumental en una sola ruta.",
      ],
    },
    en: {
      title: "Imperial cities and the Rif.",
      eyebrow_prefix: "Circuit · Imperial cities + Rif",
      place: "Tangier · Chefchaouen · Meknes · Fez · Marrakech",
      subtitle: "From Tangier to Marrakech across the cultural north, the Rif blue town, the imperial cities and the red city.",
      hero_image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=2400&q=85",
      airports: "In Tangier · Out Marrakech",
      quick_airports: "Tangier / Marrakech",
      quick_places: "Tangier · Tetouan · Chefchaouen · Volubilis · Meknes · Fez · Ifrane · Marrakech",
      highlights: "Tetouan · Chefchaouen · Volubilis · Fez el-Bali · Jemaa el-Fna",
      description_title: "A total immersion in cultural Morocco.",
      description: [
        "Morocco holds a rich historic and architectural legacy clearly seen in its «Imperial Cities».",
        "This complete circuit crosses the country from north to south discovering UNESCO medinas, the blue towns of the Rif, mountains, imperial cities and the contrasts between the Mediterranean and Marrakech.",
        "An experience designed for travellers who want the most authentic, cultural and monumental Morocco in one route.",
      ],
    },
    fr: {
      title: "Cités impériales et Rif.",
      eyebrow_prefix: "Circuit · Cités impériales + Rif",
      place: "Tanger · Chefchaouen · Meknès · Fès · Marrakech",
      subtitle: "De Tanger à Marrakech : le nord culturel, le village bleu du Rif, les cités impériales et la ville rouge.",
      hero_image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=2400&q=85",
      airports: "Arrivée Tanger · Sortie Marrakech",
      quick_airports: "Tanger / Marrakech",
      quick_places: "Tanger · Tétouan · Chefchaouen · Volubilis · Meknès · Fès · Ifrane · Marrakech",
      highlights: "Tétouan · Chefchaouen · Volubilis · Fès el-Bali · Jemaa el-Fna",
      description_title: "Une immersion totale dans le Maroc culturel.",
      description: [
        "Le Maroc conserve un riche héritage historique et architectural particulièrement visible dans ses « cités impériales ».",
        "Ce circuit complet traverse le pays du nord au sud : médinas UNESCO, villages bleus du Rif, montagnes, cités impériales et contrastes entre la Méditerranée et Marrakech.",
        "Une expérience conçue pour les voyageurs qui veulent découvrir le Maroc le plus authentique, culturel et monumental en un seul itinéraire.",
      ],
    },
  },
  route: [
    { day: 1, lat: 35.7595, lng: -5.8340, type: "airport", name: T("Tánger · Aeropuerto", "Tangier · Airport", "Tanger · Aéroport") },
    { day: 1, lat: 35.5728, lng: -5.3725, type: "unesco",  name: T("Tetuán · medina UNESCO", "Tetouan · UNESCO medina", "Tétouan · médina UNESCO") },
    { day: 2, lat: 35.2330, lng: -5.1690, type: "kasbah",  name: T("Cascadas de Akchour", "Akchour Waterfalls", "Cascades d'Akchour") },
    { day: 2, lat: 35.1689, lng: -5.2636, type: "city",    name: T("Chefchaouen · pueblo azul", "Chefchaouen · blue town", "Chefchaouen · village bleu") },
    { day: 3, lat: 34.0731, lng: -5.5547, type: "unesco",  name: T("Volubilis · ruinas romanas", "Volubilis · Roman ruins", "Volubilis · ruines romaines") },
    { day: 3, lat: 34.0556, lng: -5.5236, type: "city",    name: T("Moulay Idriss", "Moulay Idriss", "Moulay Idriss") },
    { day: 3, lat: 33.8930, lng: -5.5473, type: "kasbah",  name: T("Meknes · Bab al Mansour", "Meknes · Bab al Mansour", "Meknès · Bab al Mansour") },
    { day: 3, lat: 34.0651, lng: -4.9760, type: "city",    name: T("Fez · Riad en la medina", "Fez · Medina riad", "Fès · Riad de la médina") },
    { day: 4, lat: 34.0635, lng: -4.9737, type: "unesco",  name: T("Fez el-Bali · medina UNESCO", "Fez el-Bali · UNESCO medina", "Fès el-Bali · médina UNESCO") },
    { day: 5, lat: 33.5228, lng: -5.1106, type: "city",    name: T("Ifrane · la pequeña Suiza", "Ifrane · little Switzerland", "Ifrane · petite Suisse") },
    { day: 5, lat: 32.3373, lng: -6.3604, type: "city",    name: T("Beni Mellal", "Beni Mellal", "Beni Mellal") },
    { day: 5, lat: 31.6295, lng: -7.9811, type: "city",    name: T("Marrakech · Riad en la medina", "Marrakech · Medina riad", "Marrakech · Riad de la médina") },
    { day: 6, lat: 31.6258, lng: -7.9892, type: "unesco",  name: T("Marrakech · Jemaa el-Fna · Koutoubia", "Marrakech · Jemaa el-Fna · Koutoubia", "Marrakech · Jemaa el-Fna · Koutoubia") },
    { day: 7, lat: 31.6069, lng: -8.0363, type: "airport", name: T("Marrakech · Aeropuerto · Regreso", "Marrakech · Airport · Return", "Marrakech · Aéroport · Retour") },
  ],
  days: [DAY_CIRF_TANGER_TETUAN, DAY_CIRF_CHEFCHAOUEN, DAY_03, DAY_CIRF_FEZ_MEDINA, DAY_CIRF_FEZ_MARRAKECH, DAY_CIRF_MARRAKECH_MEDINA, DAY_CIRF_RETURN_MARRAKECH],
  details: {
    includes: {
      es: [
        "Una noche en Tetuán en riad dentro de la medina u Hotel 4★ · Media Pensión",
        "Una noche en Chefchaouen en riad dentro de la medina · Media Pensión",
        "Dos noches en Fez en riad dentro de la medina u Hotel 4★ · Media Pensión",
        "Dos noches en Marrakech en riad dentro de la medina u Hotel 5★ · Alojamiento y Desayuno",
        "Vehículo turismo o 4x4 con chófer del día 1 al día 5",
        "Visita guiada de Tetuán",
        "Visita guiada de Chefchaouen",
        "Visita guiada y entrada a Volubilis",
        "Visita guiada de Meknes",
        "Entradas a Heri es Souani y Habs Qara",
        "Visita guiada de Fez · Entrada a la Madraza",
        "Visita guiada de Marrakech · Entrada al Palacio Bahía",
        "Transfers de aeropuerto",
        "Seguro de asistencia en viaje",
      ],
      en: [
        "One night in Tetouan in a medina riad or 4★ hotel · half board",
        "One night in Chefchaouen in a medina riad · half board",
        "Two nights in Fez in a medina riad or 4★ hotel · half board",
        "Two nights in Marrakech in a medina riad or 5★ hotel · bed & breakfast",
        "Car or 4x4 with driver from day 1 to day 5",
        "Guided tour of Tetouan",
        "Guided tour of Chefchaouen",
        "Guided tour and entrance to Volubilis",
        "Guided tour of Meknes",
        "Entrance fees to Heri es Souani and Habs Qara",
        "Guided tour of Fez · Madrasa entrance fee",
        "Guided tour of Marrakech · Bahia Palace entrance fee",
        "Airport transfers",
        "Travel assistance insurance",
      ],
      fr: [
        "Une nuit à Tétouan en riad de la médina ou hôtel 4★ · demi-pension",
        "Une nuit à Chefchaouen en riad de la médina · demi-pension",
        "Deux nuits à Fès en riad de la médina ou hôtel 4★ · demi-pension",
        "Deux nuits à Marrakech en riad de la médina ou hôtel 5★ · logement et petit-déjeuner",
        "Véhicule tourisme ou 4x4 avec chauffeur du jour 1 au jour 5",
        "Visite guidée de Tétouan",
        "Visite guidée de Chefchaouen",
        "Visite guidée et entrée à Volubilis",
        "Visite guidée de Meknès",
        "Entrées à Heri es Souani et Habs Qara",
        "Visite guidée de Fès · Entrée à la médersa",
        "Visite guidée de Marrakech · Entrée au palais Bahia",
        "Transferts aéroport",
        "Assistance voyage",
      ],
    },
    excludes: {
      es: [
        "Bebidas",
        "Comidas del mediodía",
        "Cenas en Marrakech",
        "Extras personales como hammam, masajes u otros servicios no especificados",
        "Vuelos internacionales",
        "Seguro de cancelación",
      ],
      en: [
        "Drinks",
        "Lunches",
        "Dinners in Marrakech",
        "Personal extras (hammam, massages…)",
        "International flights",
        "Cancellation insurance",
      ],
      fr: [
        "Boissons",
        "Déjeuners",
        "Dîners à Marrakech",
        "Extras personnels (hammam, massages…)",
        "Vols internationaux",
        "Assurance annulation",
      ],
    },
    notes: {
      es: [
        "Opciones de vuelos: Royal Air Maroc vía Casablanca, Vueling, Ryanair u otras low-cost con vuelos directos. Consultar opciones y condiciones.",
        "Los precios se calculan según la ocupación del vehículo turismo o 4x4. El coste del transporte se reparte entre los ocupantes.",
        "Suplemento habitación individual: 300 €.",
        "Descuento niños (3-11 años) compartiendo habitación con dos adultos: 175 €.",
        "Los chóferes hispanohablantes son limitados en temporada alta.",
        "Los guías locales en medinas pueden compartirse con otros viajeros.",
        "El viaje se realiza en vehículo turismo o 4x4 con chófer local.",
        "Seguro de cancelación opcional · 45 € por persona para viajes de máximo 9 días.",
      ],
      en: [
        "Flight options: Royal Air Maroc via Casablanca, Vueling, Ryanair or other low-cost direct flights. Options on request.",
        "Rates depend on vehicle or 4x4 occupancy. Transport cost is split between passengers.",
        "Single room supplement: €300.",
        "Children discount (3-11) sharing with two adults: €175.",
        "Spanish-speaking drivers are limited in high season.",
        "In high season, medina guides may be shared with other travellers.",
        "Travel by car or 4x4 with local driver.",
        "Optional cancellation insurance · €45 per person for trips of up to 9 days.",
      ],
      fr: [
        "Options de vol : Royal Air Maroc via Casablanca, Vueling, Ryanair ou autres low-cost. Options sur demande.",
        "Tarifs selon l'occupation du véhicule ou 4x4. Le coût est partagé entre les passagers.",
        "Supplément single : 300 €.",
        "Réduction enfants (3-11 ans) partageant avec 2 adultes : 175 €.",
        "Chauffeurs hispanophones limités en haute saison.",
        "En haute saison, les guides de médina peuvent être partagés.",
        "Voyage en voiture ou 4x4 avec chauffeur local.",
        "Assurance annulation en option · 45 € par personne pour les voyages jusqu'à 9 jours.",
      ],
    },
    terms: {
      es: [
        "Reserva: 30% del importe del viaje en el momento de la reserva.",
        "Pago final: 70% restante hasta 30 días antes de la salida.",
        "En caso de emisión inmediata de vuelos: 100% del billete al reservar.",
        "Cancelación 45 días antes de la salida: 30% de gastos.",
        "Cancelación 21 días antes de la salida: 100% de gastos.",
        "Penalización adicional de 50 € por reserva en concepto de gestión.",
        "Estas condiciones aplican solo a los servicios de tierra. El seguro de cancelación no es reembolsable.",
      ],
      en: [
        "Booking: 30% at confirmation.",
        "Final payment: 70% balance up to 30 days before departure.",
        "Immediate flight ticketing: 100% of the flight at booking.",
        "Cancellation 45 days before departure: 30% fees.",
        "Cancellation 21 days before departure: 100% fees.",
        "Fixed €50 per booking management fee.",
        "Conditions apply to land services only. Cancellation insurance is non-refundable.",
      ],
      fr: [
        "Réservation : 30 % à la confirmation.",
        "Paiement final : solde de 70 % jusqu'à 30 jours avant le départ.",
        "Émission immédiate du vol : 100 % du billet à la réservation.",
        "Annulation 45 jours avant : 30 % de frais.",
        "Annulation 21 jours avant : 100 % de frais.",
        "Pénalité fixe de 50 € par réservation pour frais de gestion.",
        "Conditions applicables aux services terrestres uniquement. L'assurance annulation n'est pas remboursable.",
      ],
    },
  },
};

export default PROGRAM_CI_RIF_67;
